/**
 * ScenarioSelector - Test Scenario Selection UI
 *
 * Phase 5 - SOC Refactoring (UI Cleanup)
 *
 * Extracted from BoardContainer.tsx to centralize test scenario selection.
 * Only displayed in TestAI mode. Allows selecting predefined game scenarios for AI testing.
 *
 * RESPONSIBILITIES:
 * - Render scenario dropdown
 * - Display scenario description
 * - Handle scenario selection changes
 */

import React, { useState } from 'react';
import { getScenarioNames, getScenarioByName } from '../../services/zodiacEngine/heuristics/SavedScenarios';
import styles from './ScenarioSelector.module.css';

interface ScenarioSelectorProps {
  darkMode: boolean;
  onScenarioChange: (scenarioName: string) => void;
}

export function ScenarioSelector({
  darkMode,
  onScenarioChange,
}: ScenarioSelectorProps) {
  const [selectedScenario, setSelectedScenario] = useState<string>('');

  const handleScenarioChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const scenarioName = event.target.value;
    setSelectedScenario(scenarioName);
    onScenarioChange(scenarioName);
  };

  return (
    <>
      <p />
      <div>
        <label htmlFor="scenarioSelect">Test Scenario: </label>
        <select
          id="scenarioSelect"
          value={selectedScenario}
          onChange={handleScenarioChange}
          style={{
            padding: '5px',
            marginLeft: '5px',
            borderRadius: '4px',
            border: '1px solid #ccc',
          }}
        >
          <option value="">Select a scenario...</option>
          {getScenarioNames().map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>
      {selectedScenario && (
        <div
          style={{
            marginTop: '10px',
            padding: '8px',
            backgroundColor: darkMode ? '#2a2a2a' : '#f0f0f0',
            color: darkMode ? '#ffffff' : '#000000',
            borderRadius: '4px',
            fontSize: '14px',
            maxWidth: '300px',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            overflow: 'hidden',
          }}
        >
          <strong>Expected Outcome:</strong>{' '}
          {getScenarioByName(selectedScenario)?.description}
        </div>
      )}
    </>
  );
}
